var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-table',{attrs:{"tablenom":"sublistevaluations","cols":_vm.colonnes,"items":_vm.evaluations,"loadstatus":_vm.evaluationsLoadStatus,"deletestatus":_vm.evaluationDeleteStatus,"formroutes":_vm.evaformroutes,"actions":_vm.evaActions}})}
var staticRenderFns = []

export { render, staticRenderFns }